import React, { useContext } from "react";
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import Drawer from "@material-ui/core/Drawer";

const objType = {
  maxBooking: {
    title: "최대 예약권",
    desc: "본 이용권으로 동시 예약 가능한 최대 횟수 입니다. 예약 내역이 출석이나 결석된 이후, 추가 예약할 수 있습니다. ",
  },
  cancel: {
    title: "예약 취소권",
    desc: "본 이용권으로 예약을 취소할 수 있는 전체 횟수입니다. 예약 취소 가능 시간에 사용할 수 있고 모두 소진시 예약취소가 불가능 합니다. ",
  },
  forceCancel: {
    title: "특별 취소권",
    desc: "예약 취소 가능 시간이 지난 경우에도 예약 취소가 가능한 특별 취소 가능 횟수입니다. ",
  },
} as any;

function PassInfoPop() {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "PASS_CARD_INFO_POP",
      open: { passCardInfoPop: false },
    });
  };

  return (
    <React.Fragment>
      <Drawer
        anchor="bottom"
        open={state.passCardInfoPop}
        onClose={handleClose}
        className="picker-pop auto"
      >
        <PickerHeader title={objType[state.passCardInfoType]?.title} onClose={handleClose} />
        <div className="picker-body">
          <div className="schedule-dtl-info-pop">
            <div className="info">
              <div className="text">{objType[state.passCardInfoType]?.desc}</div>
            </div>
          </div>
        </div>
      </Drawer>
    </React.Fragment>
  );
}

export default PassInfoPop;
